import { setChatStats,updateChatStats,setChatId,setChatState,setModelState,setSidebarState,setchatHistoryState,setchatCountState } from "../Actions";

const initialState = {
   Chat : {},
   updateChat : {},
   chatID :'',
   ChatState: false,
   model:'',
   sidebarState: false,
   chatHistoryState:[],
   chatCountState:1
} 

function chatReducer(state =  initialState , action) {
  

  switch(action.type){
      case setChatStats:
        var new_stats = action.payload
        return { ...state , Chat: new_stats};

      case updateChatStats:
        var new_stats = action.payload
        return { ...state , updateChat: new_stats};

      case setChatId:
        var new_stats = action.payload
          return { ...state , chatID: new_stats};

      case setChatState:
        var new_stats = action.payload
          return { ...state , ChatState: new_stats};

      case setModelState:
        var new_stats = action.payload
          return { ...state , model: new_stats};

      case setSidebarState:
        var new_stats = action.payload
          return { ...state , sidebarState: new_stats};

      case setchatHistoryState:
        var new_stats = action.payload
          return { ...state , chatHistoryState: new_stats};

      case setchatCountState:
        var new_stats = action.payload
          return { ...state , chatCountState: new_stats};

    default:    
        return state   
       
  }  
}

export default chatReducer;